export default __webpack_public_path__ + "static/media/05.749ff077.jpg";